import * as types from '../mutation-types';

const state = {
  pin: '',
  status: '',
  error: ''
};

const getters = {
  pin: () => state.pin,
  pinConfirmation() {
    return {
      pin: state.pin,
      status: state.status,
      error: state.error
    };
  }
};

const actions = {
  setPin: ({ commit }, data) => {
    commit(types.SET_PIN_CONFIRMATION, data);
  }
};

const mutations = {
  [types.SET_PIN_CONFIRMATION](_, pin) {
    state.pin = pin;
    //  state.status = data.status;
    //  state.error = data.error || '';
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/pin.js